// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Rede_SituacaoInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** POST /rede/situacao — registra a mudança de situação de uma unidade (Full). */
import { registerContract } from './validate'

export interface Rede_SituacaoInput {
franquia_id?: number
situacao?: string
desde?: string
observacao?: string
}

registerContract('Rede_SituacaoInput', {
  franquia_id: { type: 'number',  required: false },
  situacao:    { type: 'string',  required: false },
  desde:       { type: 'string',  required: false },
  observacao:  { type: 'string',  required: false },
})
